import api from "@/services/api"

export async function getServices({ customerId }) {
  const { data } = await api.get(`/api/v1/customer/${customerId}/services`)
  return data
}
